export default () => ({
  title: "ShowDonationLevelsAboveAmount",
  type: "object",
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      default: false,
    },
  },
});
